import { CSSObject } from "@emotion/react";
import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Select, { SingleValue, MultiValue, StylesConfig } from "react-select";
import { Modal } from 'react-bootstrap';
import Table from "../../../core/common/dataTable/index";
import { all_routes } from '../../router/all_routes';
import DealsDeailsModal from '../../../core/modals/deals_modal';
import DefaultEditor from "react-simple-wysiwyg";
import { useDispatch, useSelector } from 'react-redux';
import { setActivityTogglePopup } from '../../../core/data/redux/commonSlice';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import CollapseHeader from '../../../core/common/collapse-header';
import { accountType, ascendingandDecending, documentType, LocaleData, status, statusList } from '../../../core/common/selectoption/selectoption';
import { SelectWithImage2 } from '../../../core/common/selectWithImage2';
import { useParams } from 'react-router-dom';
import { addProduct, updateProduct, updateProductPriceBook, deleteProduct, getProductDetail, getAllPricebooks, addProductPriceBook, getAllProducts, deleteProductPriceBook, getProductPriceBookDetail } from './productAPI';
import ResponseModal from "../../../core/modals/response_modal";
interface Product {
    id: number;
    name: string;
    description: string;
    code: string;
    category: string;
    createdBy: string;
    createdDate: string;
    updatedBy: string;
    updatedDate: string;
    related: {id: number; productId: string; productName: string; productPrice: string; priceBookId: number; priceBookName: string }[];
}
interface ProductForm {
    productName: string;
    productDescription: string;
    productCode: string;
    productCategory: string;
}
interface ProductPriceBook {
    productId: number;
    priceBookId: number;
    price: number;
}
interface ProductDetailData {
    id: number;
    uuid: string;
    name: string;
    description: string;
    code: string;
    category: string;
    createdBy: string;
    createdDate: string;
    updatedBy: string;
    updatedDate: string;
}
interface PriceBook {
    id: number;
    name: string;
}
interface ProductOption {
    id: number;
    productName: string;
}

const ProductDetail = () => {
    const route = all_routes
    const { id } = useParams();
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
    const [editingProduct, setEditingProduct] = useState<ProductDetailData>();
    const [editingProductPriceBook, setEditingProductPriceBook] = useState<ProductPriceBook>();
    const [listPriceBooks, setListPriceBooks] = useState<PriceBook[]>([]);
    const [listProducts, setListProducts] = useState<ProductOption[]>([]);
    const [editedProductId, setEditedProductId] = useState<number | null>(null);
    const [selectedProductPriceBookId, setSelectedProductPriceBookId] = useState<number | null>(null);
    const handleChangePriceBook = (selectedOption: any) => {
        setNewProductPrice(prev => ({
            ...prev,
            priceBookId: selectedOption.value
        }));
        setEditingProductPriceBook(prev => prev ? {
            ...prev,
            priceBookId: selectedOption.value
        } : undefined);
    };
    const handleChangeProduct = (selectedOption: any) => {
        setNewProductPrice({
            ...newProductPrice,
            productId: selectedOption.value,
        });
        setEditingProductPriceBook(prev => prev ? {
            ...prev,
            productId: selectedOption.value
        } : undefined);
    };
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setNewProduct(prevState => ({
            ...prevState,
            [name]: value
        }));
        setEditingProduct((prevState) => {
            if (!prevState) return prevState;
            return {
                ...prevState,
                [name]: value,
            };
        });
        setNewProductPrice((prevState) => {
            if (!prevState) return prevState;
            return {
                ...prevState,
                [name]: value,
            };
        });
        setEditingProductPriceBook((prevState) => {
            if (!prevState) return prevState;
            return {
                ...prevState,
                [name]: value,
            };
        });

    };
    const fetchPriceBook = async () => {
        try {
            const response = await getAllPricebooks();
            console.log("API Response:", response.data);
            if (response.data.data != null) {
                setListPriceBooks(response.data.data);
            } else {
                setListPriceBooks([]);
            }
        } catch (error) {
            setListPriceBooks([]);
        }
    }
    useEffect(() => {
        fetchPriceBook();
    }, []);

    const handleDeleteProductPriceBookClick = async (productPriceBookId: number) => {
        setSelectedProductPriceBookId(Number(productPriceBookId));
        setShowDeleteModal(true);
    }
    const handleDeleteProductPriceBookConfirm = async () => {
        if (!selectedProductPriceBookId) return;
        try {
            const response = await deleteProductPriceBook(selectedProductPriceBookId);
            if (response.status === 200) {
                fetchProductDetail();
                setResponse({ status: "success", message: "Delete product price book successfully!" });
                setSelectedProductPriceBookId(0);
            }
        } catch (error: any) {
            console.error("Failed to delete:", error);
            setResponse({ status: "error", message: error.response?.data?.message || "Failed to delete product price book." });
        } finally {
            setShowDeleteModal(false);
            setShowMessageModal(true);
        }
    };
    const fetchProducts = async () => {
        try {
            const response = await getAllProducts();
            console.log("API Response:", response.data);
            if (response.data.data != null) {
                setListProducts(response.data.data);
            } else {
                setListProducts([]);
            }
        } catch (error) {
            setListProducts([]);
        }
    }
    useEffect(() => {
        fetchProducts();
    }, []);


    const priceBookOptions = listPriceBooks.map((pb) => ({
        value: pb.id,
        label: pb.name,
    }));
    const productOptions = listProducts
        .map((product) => ({
            value: product.id,
            label: product.productName,
        }))
        .filter((item, index, self) =>
            index === self.findIndex((t) => t.value === item.value)
        );
    const [newProduct, setNewProduct] = useState<ProductForm>({
        productName: "",
        productDescription: "",
        productCode: "",
        productCategory: "",
    });
    const [newProductPrice, setNewProductPrice] = useState<ProductPriceBook>({
        productId: 0,
        priceBookId: 0,
        price: 0
    });

    const handleEditProductPriceBookClick = async (productPriceBookId: number) => {
        try {
            const response = await getProductPriceBookDetail(productPriceBookId);
            console.log("API response:", response.data.data);

            if (response.status === 200) {
                setEditingProductPriceBook(response.data.data);
                setSelectedProductPriceBookId(Number(productPriceBookId));
            }
        } catch (error) {
            console.error("Error fetching product details:", error);
        }
    }
    const handleUpdateProductPriceBook = async () => {
        try {
            const productData = {
                productId: editingProductPriceBook?.productId,
                priceBookId: editingProductPriceBook?.priceBookId,
                price: editingProductPriceBook?.price
            };
            const response = await updateProductPriceBook(selectedProductPriceBookId, productData);
            if (response.status === 200) {
                fetchProductDetail();
                setResponse({ status: "success", message: "Update product price book successfully!" });
            }
        } catch (error: any) {
            setResponse({ status: "error", message: error.response?.data?.message || "Failed to update product price book." });
        } finally {
            setShowMessageModal(true);
        }
    }
    const handleCreateProductPriceBook = async () => {
        try {
            if (!newProductPrice.priceBookId || !newProductPrice.price) {
                setResponse({ status: "error", message: "Please select a Price Book and enter a valid price." });
                return;
            }
            const productData = [{
                productId: newProductPrice.productId,
                priceBookId: newProductPrice.priceBookId,
                price: newProductPrice.price
            }];
            console.log("Dữ liệu sản phẩm trước khi gửi lên API:", productData);

            const response = await addProductPriceBook(productData);
            console.log("API Response:", response.data);

            if (response.status === 200) {
                fetchProductDetail();
                setNewProductPrice({
                    productId: productDetail?.id || 0,
                    priceBookId: 0,
                    price: 0
                });
                setResponse({ status: "success", message: "Add product price book successfully!" });
            }
        } catch (error: any) {
            setResponse({ status: "error", message: error.response?.data?.message || "Failed to add product price book." });
        } finally {
            setShowMessageModal(true);
        }
    }
    const handleCreateProduct = async () => {
        try {
            if (!newProduct.productName || !newProduct.productCode) {
                return;
            }
            const productData = {
                productName: newProduct.productName.trim(),
                productDescription: newProduct.productDescription?.trim() || "",
                productCode: newProduct.productCode.trim(),
                productCategory: newProduct.productCategory?.trim() || ""
            };

            console.log("Dữ liệu sản phẩm trước khi gửi lên API:", productData);

            const response = await addProduct(productData);
            console.log("API Response:", response.data);

            if (response.status === 200) {
                setNewProduct({
                    productName: "",
                    productDescription: "",
                    productCode: "",
                    productCategory: "",
                });
            }
        } catch (error: any) {
            console.error("Lỗi khi tạo sản phẩm:", error);
            setResponse({ status: "error", message: "Error creating product: " + (error.response?.data?.message || error.message) });
        } finally {
            setShowMessageModal(true);
        }
    };
    const handleUpdateProduct = async () => {
        if (!editingProduct?.id) {
            console.error("Error: No valid ID found for update!", editingProduct);
            setResponse({ status: "error", message: "No valid ID found for update!" });
            return;
        }
        try {
            console.log("Updating product with ID:", editingProduct.id);
            const updatedProduct = {
                productName: editingProduct.name,
                productDescription: editingProduct.description || "",
                productCode: editingProduct.code,
                productCategory: editingProduct.category || ""
            };

            console.log("Sending product update data:", updatedProduct);
            const response = await updateProduct(editingProduct.id, updatedProduct);

            if (response.status === 200) {
                console.log("Product updated successfully");
                fetchProductDetail();
                setResponse({ status: "success", message: "Product updated successfully" });
            } else {
                setResponse({ status: "error", message: "Failed to update product" });
            }
        } catch (error: any) {
            console.error("Error updating product:", error);
            const errorMessage = error.response?.data?.message || error.message || "Unknown error";
            setResponse({ status: "error", message: "Error updating product: " + errorMessage });
        } finally {
            setShowMessageModal(true);
        }
    };

    const [productDetail, setProductDetail] = useState<Product | null>(null);
    const fetchProductDetail = async () => {
        if (!id) return;
        try {
            const response = await getProductDetail(id);
            console.log("Product Detail API Response:", response.data.data);
            setProductDetail({
                ...response.data.data,
                related: response.data.data.related || []
            });
        } catch (error) {
            console.error("Error fetching deal details:", error);
        }
    };
    useEffect(() => {
        fetchProductDetail();
    }, [id]);
    useEffect(() => {
        if (productDetail?.id) {
            setNewProductPrice(prev => ({
                ...prev,
                productId: productDetail.id
            }));
        }
    }, [productDetail]);
    const handleEditClick = async (productId: number) => {
        console.log("Product ID:", productId);
        try {
            const response = await getProductDetail(productId);
            console.log("API response:", response.data.data);

            if (response.status === 200) {
                setEditingProduct(response.data.data);
                setEditedProductId(response.data.data.id);
            }
        } catch (error) {
            console.error("Error fetching product details:", error);
        }
    };
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">Product Overview </h4>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {/* Deals User */}
                            <div className="contact-head">
                                <div className="row align-items-center">
                                    <div className="col-sm-8">
                                        <ul className="contact-breadcrumb">
                                            <li>
                                                <Link to={route.products}>
                                                    <i className="ti ti-arrow-narrow-left" />
                                                    Products
                                                </Link>
                                            </li>
                                            <li>{productDetail?.name || 'N/A'}</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body pb-2">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        <div className="d-flex align-items-center mb-2">
                                            <div>
                                                <h5 className="mb-1 d-flex align-items-center justify-content-between">
                                                    <span>{productDetail?.name || "N/A"}</span>
                                                    <div className="d-flex align-items-center">
                                                        <i className="fa-solid fa-star text-warning ms-2"></i> {/* Ngôi sao */}

                                                        {/* Dropdown Menu */}
                                                        <div className="dropdown table-action ms-2">
                                                            <Link
                                                                to="#"
                                                                className="action-icon"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="true"
                                                            >
                                                                <i className="fa fa-ellipsis-v"></i>
                                                            </Link>
                                                            <div
                                                                className="dropdown-menu dropdown-menu-right"
                                                                data-popper-placement="bottom-start"
                                                            >
                                                                {/* Edit Action */}
                                                                <Link
                                                                    className="dropdown-item edit-popup"
                                                                    to="#"
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#edit_Product"
                                                                    onClick={() => productDetail?.id && handleEditClick(productDetail?.id)}
                                                                >
                                                                    <i className="ti ti-edit text-blue"></i> Edit
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </h5>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Deals User */}
                        </div>
                        {/* Deals Sidebar */}
                        <div className="col-xl-3 theiaStickySidebar">
                            <div className="card">
                                <div className="card-body p-3">
                                    <h6 className="mb-3 fw-semibold">Product Information</h6>
                                    <ul>
                                        <li className="row mb-3">
                                            <span className="col-6">Name</span>
                                            <span className="col-6">{productDetail?.name || "N/A"}</span>
                                        </li>
                                        <li className="row mb-3">
                                            <span className="col-6">Description</span>
                                            <span className="col-6">{productDetail?.description || "N/A"}</span>
                                        </li>
                                        <li className="row mb-3">
                                            <span className="col-6">Code</span>
                                            <span className="col-6">{productDetail?.code || "N/A"}</span>
                                        </li>
                                        <li className="row mb-3">
                                            <span className="col-6">Category</span>
                                            <span className="col-6">{productDetail?.category || "N/A"}</span>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li className="row mb-3">
                                            <span className="col-6">Create At</span>
                                            <span className="col-6">{productDetail?.createdDate || "N/A"}</span>
                                        </li>
                                        <li className="row mb-0">
                                            <span className="col-6">Create By</span>
                                            <span className="col-6">
                                                {productDetail?.createdBy || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li className="row mb-3">
                                            <span className="col-6">Last Modified</span>
                                            <span className="col-6">{productDetail?.updatedDate || "N/A"}</span>
                                        </li>
                                        <li className="row mb-0">
                                            <span className="col-6">Modified By</span>
                                            <span className="col-6">
                                                {productDetail?.updatedBy || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* /Deals Sidebar */}
                        {/* Deals Details */}
                        <div className="col-xl-9">
                            {/* Tab Content */}
                            <div className="tab-content pt-0">
                                {/* Activities */}
                                <div className="tab-pane active show" id="activities">
                                    <div className="card">
                                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                            <h4 className="fw-semibold">Related Price Book</h4>
                                            <button
                                                className="btn btn-primary"
                                                data-bs-toggle="modal"
                                                data-bs-target="#add_pricebook"
                                            >
                                                Add To Price Book
                                            </button>
                                        </div>
                                        <div className="table-responsive custom-table">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Price Book Name</th>
                                                            <th>Price Book Price</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productDetail?.related && productDetail.related.length > 0 ? (
                                                            productDetail.related.map((item) => (
                                                                <tr key={item.priceBookId}>
                                                                    <td>{item.priceBookName}</td>
                                                                    <td>{item.productPrice}</td>
                                                                    <td>
                                                                        <div className="d-flex gap-2">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#edit_product_pricebook"
                                                                                onClick={() => handleEditProductPriceBookClick(item.id)}
                                                                            >
                                                                                <i className="ti ti-edit text-blue"></i> Edit
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                onClick={() => handleDeleteProductPriceBookClick(item.priceBookId)}
                                                                            >
                                                                                <i className="ti ti-trash text-danger"></i> Delete
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={3} className="text-center text-muted">
                                                                    No Data
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Activities */}
                                {/* Notes */}
                                <div className="tab-pane fade" id="notes">
                                    <div className="card">
                                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                            <h4 className="fw-semibold">Notes</h4>
                                            <div className="d-inline-flex align-items-center">
                                                <div className="form-sort me-3 mt-0">
                                                    <i className="ti ti-sort-ascending-2" />
                                                    <Select
                                                        className="select"
                                                        options={ascendingandDecending}
                                                        placeholder="Ascending"
                                                        classNamePrefix="react-select"
                                                    />
                                                </div>
                                                <Link
                                                    to="#"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#add_notes"
                                                    className="link-purple fw-medium"
                                                >
                                                    <i className="ti ti-circle-plus me-1" />
                                                    Add New
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="notes-activity">
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center justify-content-between pb-2">
                                                            <div className="d-inline-flex align-items-center mb-2">
                                                                <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                    <ImageWithBasePath
                                                                        src="assets/img/profiles/avatar-19.jpg"
                                                                        alt="img"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">
                                                                        Darlee Robertson
                                                                    </h6>
                                                                    <p className="mb-0">15 Sep 2023, 12:10 pm</p>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2">
                                                                <div className="dropdown">
                                                                    <Link
                                                                        to="#"
                                                                        className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="ti ti-dots-vertical" />
                                                                    </Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#">
                                                                            <i className="ti ti-edit text-blue me-1" />
                                                                            Edit
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#">
                                                                            <i className="ti ti-trash text-danger me-1" />
                                                                            Delete
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-medium mb-1">
                                                            Notes added by Antony
                                                        </h5>
                                                        <p>
                                                            A project review evaluates the success of an
                                                            initiative and identifies areas for improvement.
                                                            It can also evaluate a current project to
                                                            determine whether it's on the right track. Or, it
                                                            can determine the success of a completed project.{" "}
                                                        </p>
                                                        <div className="d-inline-flex align-items-center flex-wrap">
                                                            <div className="note-download me-3">
                                                                <div className="note-info">
                                                                    <span className="note-icon bg-secondary-success">
                                                                        <i className="ti ti-file-spreadsheet" />
                                                                    </span>
                                                                    <div>
                                                                        <h6 className="fw-medium mb-1">
                                                                            Project Specs.xls
                                                                        </h6>
                                                                        <p>365 KB</p>
                                                                    </div>
                                                                </div>
                                                                <Link to="#">
                                                                    <i className="ti ti-arrow-down" />
                                                                </Link>
                                                            </div>
                                                            <div className="note-download">
                                                                <div className="note-info">
                                                                    <span className="note-icon">
                                                                        <ImageWithBasePath
                                                                            src="assets/img/media/media-35.jpg"
                                                                            alt="img"
                                                                        />
                                                                    </span>
                                                                    <div>
                                                                        <h6 className="fw-medium mb-1">
                                                                            090224.jpg
                                                                        </h6>
                                                                        <p>365 KB</p>
                                                                    </div>
                                                                </div>
                                                                <Link to="#">
                                                                    <i className="ti ti-arrow-down" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className="notes-editor">
                                                            {/* <div
                                                                className="note-edit-wrap"
                                                                style={{ display: isEditor ? "block" : "none" }}
                                                            >
                                                                <DefaultEditor className="summernote" />
                                                                <div className="text-end note-btns">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-light add-cancel"
                                                                        onClick={() => setIsEditor(!isEditor3)}
                                                                    >
                                                                        Cancel
                                                                    </Link>
                                                                    <Link to="#" className="btn btn-primary">
                                                                        Save
                                                                    </Link>
                                                                </div>
                                                            </div> */}
                                                            <div className="text-end">
                                                                {/* <Link
                                                                    to="#"
                                                                    className="add-comment link-purple fw-medium"
                                                                    onClick={() => setIsEditor(!isEditor)}
                                                                >
                                                                    <i className="ti ti-square-plus me-1" />
                                                                    Add Comment
                                                                </Link> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center justify-content-between pb-2">
                                                            <div className="d-inline-flex align-items-center mb-2">
                                                                <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                    <ImageWithBasePath
                                                                        src="assets/img/profiles/avatar-20.jpg"
                                                                        alt="img"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">Sharon Roy</h6>
                                                                    <p className="mb-0">18 Sep 2023, 09:52 am</p>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2">
                                                                <div className="dropdown">
                                                                    <Link
                                                                        to="#"
                                                                        className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="ti ti-dots-vertical" />
                                                                    </Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#">
                                                                            <i className="ti ti-edit text-blue me-1" />
                                                                            Edit
                                                                        </Link>
                                                                        <Link className="dropdown-item" to="#">
                                                                            <i className="ti ti-trash text-danger me-1" />
                                                                            Delete
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-medium mb-1">
                                                            Notes added by Antony
                                                        </h5>
                                                        <p>
                                                            A project plan typically contains a list of the
                                                            essential elements of a project, such as
                                                            stakeholders, scope, timelines, estimated cost and
                                                            communication methods. The project manager
                                                            typically lists the information based on the
                                                            assignment.
                                                        </p>
                                                        <div className="d-inline-flex align-items-center flex-wrap">
                                                            <div className="note-download me-3">
                                                                <div className="note-info">
                                                                    <span className="note-icon bg-secondary-success">
                                                                        <i className="ti ti-file-text" />
                                                                    </span>
                                                                    <div>
                                                                        <h6 className="fw-medium mb-1">
                                                                            Andrewpass.txt
                                                                        </h6>
                                                                        <p>365 KB</p>
                                                                    </div>
                                                                </div>
                                                                <Link to="#">
                                                                    <i className="ti ti-arrow-down" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className="reply-box">
                                                            <p>
                                                                The best way to get a project done faster is to
                                                                start sooner. A goal without a timeline is just
                                                                a dream.The goal you set must be challenging. At
                                                                the same time, it should be realistic and
                                                                attainable, not impossible to reach.
                                                            </p>
                                                            <p>
                                                                Commented by{" "}
                                                                <span className="text-purple">Aeron</span> on 15
                                                                Sep 2023, 11:15 pm
                                                            </p>
                                                            <Link to="#" className="btn">
                                                                <i className="ti ti-arrow-back-up-double" />
                                                                Reply
                                                            </Link>
                                                        </div>
                                                        <div className="notes-editor">
                                                            <div
                                                                className="note-edit-wrap"
                                                            // style={{
                                                            //     display: isEditor2 ? "block" : "none",
                                                            // }}
                                                            >
                                                                <DefaultEditor className="summernote" />
                                                                {/* <div className="text-end note-btns">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-light add-cancel"
                                                                        onClick={() => setIsEditor2(!isEditor3)}
                                                                    >
                                                                        Cancel
                                                                    </Link>
                                                                    <Link to="#" className="btn btn-primary">
                                                                        Save
                                                                    </Link>
                                                                </div> */}
                                                            </div>
                                                            {/* <div className="text-end">
                                                                <Link
                                                                    to="#"
                                                                    className="add-comment link-purple fw-medium"
                                                                    onClick={() => setIsEditor2(!isEditor2)}
                                                                >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </Link> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-0">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <ImageWithBasePath
                                                                    src="assets/img/profiles/avatar-21.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Vaughan</h6>
                                                                <p className="mb-0">20 Sep 2023, 10:26 pm</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <Link
                                                                    to="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </Link>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <Link className="dropdown-item" to="#">
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </Link>
                                                                    <Link className="dropdown-item" to="#">
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        Projects play a crucial role in the success of
                                                        organizations, and their importance cannot be
                                                        overstated. Whether it's launching a new product,
                                                        improving an existing
                                                    </p>
                                                    <div className="notes-editor">
                                                        <div
                                                            className="note-edit-wrap"
                                                        // style={{
                                                        //     display: isEditor3 ? "block" : "none",
                                                        // }}
                                                        >
                                                            <DefaultEditor className="summernote" />
                                                            <div className="text-end note-btns">
                                                                <Link
                                                                    to="#"
                                                                    className="btn btn-light add-cancel"
                                                                // onClick={() => setIsEditor3(!isEditor3)}
                                                                >
                                                                    Cancel
                                                                </Link>
                                                                <Link to="#" className="btn btn-primary">
                                                                    Save
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <Link
                                                                to="#"
                                                                className="add-comment link-purple fw-medium"
                                                            // onClick={() => setIsEditor3(!isEditor3)}
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Notes */}
                            {/* Email */}
                            <div className="tab-pane fade" id="email">
                                <div className="card">
                                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="fw-semibold">Email</h4>
                                        <div className="d-inline-flex align-items-center">
                                            <OverlayTrigger
                                                placement="left"
                                                overlay={
                                                    <Tooltip id="refresh-tooltip">
                                                        There are no email accounts configured, Please
                                                        configured your email account in order to Send/
                                                        Create EMails
                                                    </Tooltip>
                                                }
                                            >
                                                <Link to="#">
                                                    <i className="ti ti-circle-plus me-1" />
                                                    Create Email
                                                </Link>
                                            </OverlayTrigger>
                                            {/* <Link
                            to="#"
                            className="link-purple fw-medium"
                            data-bs-toggle="tooltip"
                            data-bs-placement="left"
                            data-bs-custom-className="tooltip-dark"
                            data-bs-original-title=""
                          >
                            <i className="ti ti-circle-plus me-1" />
                            Create Email
                          </Link> */}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="card border mb-0">
                                            <div className="card-body pb-0">
                                                <div className="row align-items-center">
                                                    <div className="col-md-8">
                                                        <div className="mb-3">
                                                            <h4 className="fw-medium mb-1">
                                                                Manage Emails
                                                            </h4>
                                                            <p>
                                                                You can send and reply to emails directly via
                                                                this section.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 text-md-end">
                                                        <div className="mb-3">
                                                            <Link
                                                                to="#"
                                                                className="btn btn-primary"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#create_email"
                                                            >
                                                                Connect Account
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Email */}
                        </div>
                        {/* /Tab Content */}
                    </div>
                    {/* /Deals Details */}
                </div>
            </div>

            {/* /Page Wrapper */}
            {/* Success Contact */}
            {/* Add Contact Role */}
            <div className="modal custom-modal fade" id="add_contact" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Contact Roles</h5>
                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="mb-2">
                                    {/* <Select
                                        isMulti
                                        options={contactOptions}
                                        value={contactOptions.filter((option) => selectedContactRoles.includes(Number(option.value)))}
                                        onChange={handleChangeContactRole}
                                        placeholder="Search and select contacts..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        menuPlacement="auto"
                                        closeMenuOnSelect={false}
                                        styles={customStyles}
                                    /> */}
                                </div>

                                <div className="modal-btn text-end">
                                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                                        Cancel
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        // onClick={handleConfirmAddContactRoles}
                                        data-bs-dismiss="modal"
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Contact Role*/}
            {/* Edit Contact Role*/}
            <div className="modal custom-modal fade" id="edit_contact" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Contact Roles</h5>
                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="mb-2">
                                    {/* <Select
                                        isMulti
                                        options={contactOptions}
                                        value={contactOptions.filter((option) => selectedContactRoles.includes(Number(option.value)))}
                                        onChange={handleChangeContactRole}
                                        placeholder="Search and select contacts..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        menuPlacement="auto"
                                        closeMenuOnSelect={false}
                                        styles={customStyles}
                                    /> */}
                                </div>

                                <div className="modal-btn text-end">
                                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                                        Cancel
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        // onClick={handleConfirmAddContactRoles}
                                        data-bs-dismiss="modal"
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Contact Roles */}
            {/* Edit Selected Contact Role*/}
            <div className="modal custom-modal fade" id="edit_selected_contactroles" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Contact Role</h5>
                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Contact Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        // value={selectedContactRole?.contactName || ""}
                                        disabled
                                    />
                                </div>
                                {/* <div className="mb-3">
                                    <label className="form-label fw-semibold">Select Role</label>
                                    <select
                                        className="form-select"
                                        value={selectedRole}
                                        onChange={(e) => setSelectedRole(e.target.value)}
                                    >
                                        <option value="">Choose a role</option>
                                        {rolesOfContactRole.map((role) => (
                                            <option key={role.value} value={role.value}>
                                                {role.label}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}

                                <div className="modal-btn text-end">
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        data-bs-dismiss="modal"
                                    // onClick={handleUpdateContactRole}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Selected Contact Role */}
            {/* Choose Price Book */}
            <div className="modal custom-modal fade" id="choose_pricebook" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Choose Price Book</h5>
                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="text-muted">
                                Select a Price Book to associate with this opportunity. You can add products only from the Price Book you associate with this opportunity. <strong>Changing the Price Book deletes all products from the opportunity.</strong>
                            </p>
                            {/* <form>
                    <div className="mb-2">
                      <Select
                        options={priceBookOptions} // Danh sách Price Book
                        value={priceBookOptions.find((option) => option.value === selectedPriceBook)}
                        onChange={handleChangePriceBook} // Hàm xử lý thay đổi
                        placeholder="Select a Price Book..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                        menuPlacement="auto"
                        styles={customStyles}
                      />
                    </div>
    
                    <div className="modal-btn text-end">
                      <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                        Cancel
                      </Link>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirmChoosePriceBook} 
                        data-bs-dismiss="modal"
                      >
                        Confirm
                      </button>
                    </div>
                  </form> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* /Choose Price Book */}
            {/* /Add Owner */}
            {/* /Deal Status */}
            {/* Add New Product */}
            <div
                className="offcanvas offcanvas-end offcanvas-large"
                tabIndex={-1}
                id="offcanvas_add"
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="fw-semibold">Add New Product</h5>
                    <button
                        type="button"
                        className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    >
                        <i className="ti ti-x" />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <form>
                        <div className="accordion" id="main_accordion">
                            {/* Basic Info */}
                            <div className="accordion-item rounded mb-3">
                                <div className="accordion-header">
                                    <Link
                                        to="#"
                                        className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#basic"
                                    >
                                        <span className="avatar avatar-md rounded text-dark border me-2">
                                            <i className="ti ti-shopping-cart fs-20" />
                                        </span>
                                        Basic Information
                                    </Link>
                                </div>
                                <div
                                    className="accordion-collapse collapse show"
                                    id="basic"
                                    data-bs-parent="#main_accordion"
                                >
                                    <div className="accordion-body border-top">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">
                                                        Product Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="productName"
                                                        value={newProduct.productName}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">
                                                        Product Code <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="productCode"
                                                        value={newProduct.productCode}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">Category</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="category"
                                                        value={newProduct.productCategory}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-0">
                                                    <label className="col-form-label">Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={5}
                                                        name="productDescription"
                                                        value={newProduct.productDescription}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Basic Info */}
                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                data-bs-dismiss="offcanvas"
                                className="btn btn-light me-2"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleCreateProduct}
                            >
                                Create
                            </button>
                        </div>
                        <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                    </form>
                </div>
            </div>
            {/* /Add New Pipeline */}
            {/* Edit Product */}
            <div
                className="offcanvas offcanvas-end offcanvas-large"
                tabIndex={-1}
                id="edit_Product"
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="fw-semibold">Edit Product</h5>
                    <button
                        type="button"
                        className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    >
                        <i className="ti ti-x" />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <form>
                        <div className="accordion" id="main_accordion_2">
                            {/* Basic Info */}
                            <div className="accordion-item rounded mb-3">
                                <div className="accordion-header">
                                    <Link
                                        to="#"
                                        className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#basic_edit"
                                    >
                                        <span className="avatar avatar-md rounded text-dark border me-2">
                                            <i className="ti ti-shopping-cart fs-20" />
                                        </span>
                                        Basic Information
                                    </Link>
                                </div>
                                <div
                                    className="accordion-collapse collapse show"
                                    id="basic_edit"
                                    data-bs-parent="#main_accordion_2"
                                >
                                    <div className="accordion-body border-top">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">
                                                        Product Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        value={editingProduct?.name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">
                                                        Product Code <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="code"
                                                        value={editingProduct?.code}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="col-form-label">Category</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="category"
                                                        value={editingProduct?.category}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-0">
                                                    <label className="col-form-label">Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={5}
                                                        name="description"
                                                        value={editingProduct?.description}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Basic Info */}
                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                data-bs-dismiss="offcanvas"
                                className="btn btn-light me-2"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdateProduct}
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/* Edit Product Price Book */}
            <div className="modal custom-modal fade" id="edit_product_pricebook" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Product Price Book</h5>
                            <button className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="mb-2">
                                    <label className="form-label">Product</label>
                                    <Select
                                        options={productOptions}
                                        value={productOptions.find((option) => option.value === editingProductPriceBook?.productId)}
                                        onChange={handleChangeProduct}
                                        placeholder="Select a Product..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        isDisabled={true}
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Price Book</label>
                                    <Select
                                        options={priceBookOptions}
                                        value={priceBookOptions.find((option) => option.value === editingProductPriceBook?.priceBookId)}
                                        onChange={handleChangePriceBook}
                                        placeholder="Select a Price Book..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Enter Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter product price"
                                        name="price"
                                        value={editingProductPriceBook?.price}
                                        onChange={handleInputChange}
                                        min="0"
                                    />
                                </div>

                                <div className="modal-btn text-end">
                                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                                        Cancel
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        data-bs-dismiss="modal"
                                        onClick={handleUpdateProductPriceBook}
                                    >
                                        Confirm
                                    </button>
                                    <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Edit Product Price Book */}
            {/* Add To Price Book */}
            <div className="modal custom-modal fade" id="add_pricebook" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add To Price Book</h5>
                            <button className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="mb-2">
                                    <label className="form-label">Choose Product</label>
                                    <Select
                                        options={productOptions}
                                        value={productOptions.find((option) => option.value === newProductPrice.productId)}
                                        onChange={handleChangeProduct}
                                        placeholder="Select a Product..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Price Book</label>
                                    <Select
                                        options={priceBookOptions}
                                        value={priceBookOptions.find((option) => option.value === newProductPrice.priceBookId)}
                                        onChange={handleChangePriceBook}
                                        placeholder="Select a Price Book..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Enter Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter product price"
                                        name="price"
                                        value={newProductPrice.price}
                                        onChange={handleInputChange}
                                        min="0"
                                    />
                                </div>

                                <div className="modal-btn text-end">
                                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                                        Cancel
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        data-bs-dismiss="modal"
                                        onClick={handleCreateProductPriceBook}
                                    >
                                        Confirm
                                    </button>
                                    <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Add To Price Book */}
            {/* /Edit Product */}
            {/* Delete Stage */}
            {/* <Modal show={openModal} onHide={() => setOpenModal(false)}>
                <div className="modal-body">
                    <div className="text-center">
                        <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                            <i className="ti ti-trash-x fs-36 text-danger" />
                        </div>
                        <h4 className="mb-2">Remove Stage?</h4>
                        <p className="mb-0">
                            Are you sure you want to remove <br /> stage you selected.
                        </p>
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <Link
                                to="#"
                                className="btn btn-light me-2"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </Link>
                            <Link to={route.contactList} className="btn btn-danger">
                                Yes, Delete it
                            </Link>
                        </div>
                    </div>
                </div>
            </Modal> */}
            {/* /Delete Stage */}
            {/* Delete Price Book Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <div className="modal-body">
                    <div className="text-center">
                        <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                            <i className="ti ti-trash-x fs-36 text-danger" />
                        </div>
                        <h4 className="mb-2">Remove Related Price Book ?</h4>
                        <p className="mb-0">
                            Are you sure you want to remove <br /> this price book product?
                        </p>
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <button className="btn btn-light me-2" onClick={() => setShowDeleteModal(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-danger" onClick={handleDeleteProductPriceBookConfirm}>
                                Yes, Delete it
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )

};
export default ProductDetail;

